import { apiService } from './index';
import {
    LegalProceeding,
    LegalProceedingFilter,
    LegalProceedingHistorical,
} from '../shared/types/legalProceedings/legalProceedings';

export const asyncGetLegalProceedings = async (
    filters: LegalProceedingFilter,
    page?: number,
    pageSize?: number
): Promise<{ items: LegalProceeding[]; length: number }> => {
    try {
        const {
            items: data,
        }: {
            items: { items: LegalProceeding[]; length: number };
        } = await apiService.get('/api/legal-proceedings', {
            limit: pageSize || 20,
            page: page || 0,
            ...filters,
        });

        return data || { items: [], length: 0 };
    } catch (error) {
        return { items: [], length: 0 };
    }
};

export const asyncCreateLegalProceeding = async (
    legalProceeding: LegalProceeding
): Promise<LegalProceeding | undefined> => {
    try {
        const {
            items: data,
        }: {
            items: LegalProceeding;
        } = await apiService.post('/api/legal-proceedings', legalProceeding);

        return data;
    } catch (error) {}
};

export const asyncGetLegalProceeding = async (
    idLegalProceeding: string
): Promise<LegalProceeding | undefined> => {
    try {
        const {
            items: data,
        }: {
            items: LegalProceeding;
        } = await apiService.get(`/api/legal-proceedings/${idLegalProceeding}`);

        return data;
    } catch (error) {}
};

export const asyncUpdateLegalProceeding = async (
    id: string,
    legalProceeding: LegalProceeding
): Promise<LegalProceeding | undefined> => {
    try {
        const {
            items: data,
        }: {
            items: LegalProceeding;
        } = await apiService.patch(
            `/api/legal-proceedings/${id}`,
            legalProceeding
        );

        return data;
    } catch (error) {}
};

export const asyncGetLegalProceedingsHistorical = async (
    idLegalProceeding: string
): Promise<LegalProceedingHistorical[] | undefined> => {
    try {
        const {
            items: data,
        }: {
            items: LegalProceedingHistorical[];
        } = await apiService.get(
            `/api/legal-proceedings/${idLegalProceeding}/historical`
        );

        return data;
    } catch (error) {}
};
